// This file serves as a central export point for all assets used in the application.

// assets for profile screen
import ProfileChipPng from "./profile/chip.png";
import ProfileSparklePng from "./profile/sparkle.png";
import ProfileLevelFramePng from "./profile/level/profile_level_frame.png";
import ProfileLevelProgressBarLightPng from "./profile/level/profile_level_progress_bar_light.png";
import ProfileLevelProgressBarFramePng from "./profile/level/profile_level_progress_bar_frame.png";
import ProfileLevelProgressBarFillPng from "./profile/level/profile_level_progress_bar_fill.png";
import AvatarFramePng from "./profile/avatarFrame/avatar_frame.png";
import AvatarFrameSparklePng from "./profile/avatarFrame/avatar_frame_sparkle.png";
import AvatarFrameGradientRedPng from "./profile/avatarFrame/avatar_frame_gradient_red.png";
import AvatarFrameVipPng from "./profile/avatarFrame/avatar_frame_vip.png";
import AvatarFrameGradientGoldPng from "./profile/avatarFrame/avatar_frame_gradient_gold.png";
import AvatarFrameGradientBluePng from "./profile/avatarFrame/avatar_frame_gradient_blue.png";
import VipBadgeFramePng from "./profile/vip_badge_frame.png";
import UsernameFramePng from "./profile/username_frame.png";
import UsernameFrameDownLightPng from "./profile/username_frame_down_light.png";

// assets for navigation bar
import NotificationBackgroundPng from "./nav/notification_background.png";
import BtnNavChipPng from "./nav/btn_chip.png";
import BtnNavBellPng from "./nav/btn_bell.png";
import BtnNavOptionsPng from "./nav/btn_options.png";

// common assets for main screen
import BtnMainBackground from "./main/common/btn_background.png";
import MainUsersLiveFramePng from "./main/common/users_live_frame.png";
import MainUsersLiveFrameSparklePng from "./main/common/users_live_frame_sparkle.png";

// assets for main screen buttons
import TitleMainVipPng from "./main/vipButton/title_vip.png";
import BtnMainVipPng from "./main/vipButton/btn_vip.png";
import TitleMainPlayNowPng from "./main/playNowBtn/title_play_now.png";
import BtnMainPlayNowPng from "./main/playNowBtn/play.png";
import TitleMainTournamentsPng from "./main/tournamentsBtn/title_tournaments.png";
import BtnMainTournamentsPng from "./main/tournamentsBtn/btn_tournaments.png";

// assets for bottom navigation
import BottomPng from "./bottom/bottom.png";
import BottomlPng from "./bottom/bottoml.png";
import BottomLightUpPng from "./bottom/lightUp.png";
import BottomLightDownPng from "./bottom/lightDown.png";
import BtnBottomRankingPng from "./bottom/btn_ranking.png";
import BtnBottomLobbyPng from "./bottom/btn_lobby.png";
import BtnBottomBonusesPng from "./bottom/btn_bonuses.png";
import BtnBottomBonusesCollectPng from "./bottom/btn_bonuses_collect.png";
import BtnBottomBonusesCollectLightPng from "./bottom/btn_bonuses_collect_light.png";

// assets for sidebar
import SidebarBackgroundPng from "./sidebar/sidebar__background.png";
import BtnSidebarClosePng from "./sidebar/btn_sidebar_close.png";
import SidebarTopLightPng from "./sidebar/sidebar_top_light.png";
import SidebarLeftLightPng from "./sidebar/sidebar_left_light.png";
import SidebarSeparatorLightPng from "./sidebar/sidebar_separator_light.png";
import * as SidebarAssets from "./sidebar/content/index";

//assets for modal
import NotificationPng from "./popup/notification.png";
import RecycleBin from "./popup/recycle_bin.png";
import MessagesPng from "./popup/messages.png";
import HeaderGlow from "./popup/header_glow.png";
import LightLines from "./popup/LightsLines.png";

//assets for profile modal
import AvatarModalPng from "./profile/AvatarModal.png";
import BtnCloseModal from "./profile/Btn_Close.png";
import BtnEditModal from "./profile/btn_edit.png";
import NamePng from "./profile/Name.png";
import BtnPhotoModal from "./profile/Btn_Photo.png";
import StarPng from "./profile/star.png";
import ChipPng from "./profile/chip.png";
import StatisticsDownLightPng from "./profile/statisticDownLight.png";
import StatisticsUpLightPng from "./profile/statisticsUpLight.png";
import TimerBackgroundPng from "./profile/timerBackground.png";
import WinsTitle from "./profile/winsTitle.png";
import LosesTitle from "./profile/losesTitle.png";
import ChipsTitle from "./profile/chipsTitle.png";
import CircleGold from "./profile/circleGold.png";
import CircleBlue from "./profile/circleBlue.png";
import CircleGreen from "./profile/circleGreen.png";
import DateLights from "./profile/DateLights.png";
import BottomButtons from "./profile/bottomBtns.png";
import LoginTitle from "./popup/loginTitle.png";

import StatisticsText from "./profile/statisticsText.png";
import ProfileScore from "./profile/profileScore.png";
import ProfileImage from "./profile/profileImage.png";
import ProfileTitlePopup from "./profile/profileTitlePopup.png";
import InputField from "./profile/inputField.png";
import SaveBtn from "./profile/saveBtn.png";
import SaveButton from "./profile/saveButton.png";
import LightsHeader from "./profile/lightsHeader.png";
import ProfileRegistration from "./profile/registration_background.png";
import GoogleBtn from "./profile/GoogleBtn.png";
import FacebookBtn from "./profile/FacebookBtn.png";
import RegistrationTitle from "./profile/registrationTitle.png";
import BonusesHover from "./bottom/BonusesHover.png";
import CityPng from "./lobby/city.png";
import LeftArrowPng from "./carousel/leftArrow.png";
import RightArrowPng from "./carousel/rightArrow.png";
import LightsLevels from "./lobby/lightslevels.png";
import TablesContainerPng from "./lobby/tablesContainer.png";
import InvitesTitlePng from "./popup/invitesTitle.png";
import InvitedPlayerBackground from "./popup/invitedPlayerBackground.png";
import RedChipsPng from "./popup/redChips.png";
import InviteNewPlayerPng from "./popup/inviteNewPlayer.png";
import BronzeTrophee from "./profile/tournaments/BronzeTrophee.png";
import GoldTrophee from "./profile/tournaments/GoldTrophee.png";
import SilverTrophee from "./profile/tournaments/SilverTrophee.png";
import FirstCup from "./profile/tournaments/FirstCup.png";
import SecondCup from "./profile/tournaments/SecondCup.png";
import ThirdCup from "./profile/tournaments/ThirdCup.png";
import FirstBackground from "./profile/tournaments/FirstPlaceBckd.png";
import SecondBackground from "./profile/tournaments/SecondPlaceBckd.png";
import ThirdBackground from "./profile/tournaments/ThirdPlaceBckd.png";
import TotalLights from "./profile/tournaments/totalLights.png";
import SilverLights from "./profile/tournaments/silverLights.png";
import UnderTitleLight from "./profile/tournaments/underTitleLight.png";
import BuyBtn from "./profile/BuyVip/buyNow.png";
import BuyVipBtn from "./profile/BuyVip/buyNowBtn.png";
import SmallVipOne from "./profile/BuyVip/smallVip1.png";
import SmallVipSix from "./profile/BuyVip/smallVip6.png";
import SmallVipTwelve from "./profile/BuyVip/smallVip12.png";
import VipOneImage from "./profile/BuyVip/Vip1Image.png";
import VipSixImage from "./profile/BuyVip/Vip6image.png";
import VipTwelveImage from "./profile/BuyVip/Vip12image.png";
import VipBackground from "./profile/BuyVip/vipBackground.png";
import VipBtnLights from "./profile/BuyVip/btnLights.png";
import VipBackgroundLandscape from "./profile/BuyVip/vipBackgroundLandscape.png";
import buyNowPink from "./profile/BuyChips/buyNowPink.png";
import buyNowChips from "./profile/BuyChips/buyNowBtn.png";
import chipImgOne from "./profile/BuyChips/chipImgOne.png";
import chipImgTwo from "./profile/BuyChips/chipsImgTwo.png";
import chipImgThree from "./profile/BuyChips/chipImgThree.png";
import ChipsBackgrOne from "./profile/BuyChips/ChipsBackgrOne.png";
import ChipsBackgrTwo from "./profile/BuyChips/ChipsBackgrTwo.png";
import goldChipIcon from "./profile/BuyChips/goldChipIcon.png";
import ChipsBackgrOneLand from "./profile/BuyChips/ChipsOneBackgrOneLand.png";
import ChipsBackgrTwoLand from "./profile/BuyChips/ChipsBackgrTwoLand.png";
import LightBtn from "./profile/light.png";
import mainLobbyBtn from "./tournaments/mainBtn.png";
import mainLobbyBtnActive from "./tournaments/mainBtnActive.png";
import MainBtnMobile from "./tournaments/mainBtnMobile.png";
import SearchTitlePng from "./profile/searchTitlePopup.png";
import mainLobbyBtnDesktop from "./tournaments/mainBtnDesktop.png";
import ButtonRegister from "./tournaments/Btn_register.png";
import WinButtonCoins from "./tournaments/rewardChips.png";
import WinButton from "./tournaments/win_btn.png";
import BronzeButton from "./tournaments/bronze_win.png";
import GoldButton from "./tournaments/gold_btn.png";
import EntryInfoLight from "./tournaments/entryLight.png";
import TournamentsChipImg from "./tournaments/chipImage.png";
import TournamentsTrofeeBronze from "./tournaments/trophee_icon_bronze.png";
import TournamentsTrofeeSilver from "./tournaments/trophee_silver.png";
import TournamentsTrofeeGold from "./tournaments/trophee_gold.png";
import TropheeGold from "./tournaments/tournamentFirst.png";
import TropheeSilver from "./tournaments/tournamentsTwo.png";
import TropheeBronze from "./tournaments/TournamentsThree.png";
import RewardChipsIcon from "./tournaments/chipImage.png";
import EntryChipsIcon from "./tournaments/TournamentYellowChip.png";
import TournamentChipsIcon from "./tournaments/TournamentBlueChip.png";
import SignupBtn from "./tournaments/SignupBtn.png";
import RewardChips from "./tournaments/rewardChips.png";
import RewardsPurpleLight from "./tournaments/tournamentPurpleLight.png";
import RewardsBronzeLight from "./tournaments/rewardBronzeLight.png";
import RewardsBlueLight from "./tournaments/rewardBlueLight.png";

//assets for ranking table
import RankingTabBtn from "./ranking/RankingTabBtn.png";
import RankingTabBtnSelected from "./ranking/RankingTabBtnSelected.png";
import RankBgr1 from "./ranking/RankBgr1.png";
import RankBgr2 from "./ranking/RankBgr2.png";
import RankBgr3 from "./ranking/RankBgr3.png";
import RankBgrRegular from "./ranking/RankBgrRegular.png";

import RankExp from "./ranking/RankExp.png";
import RankChip from "./ranking/RankChip.png";
import RankLevelBorder from "./ranking/RankLevelBorder.png";
import RankNameBorder from "./ranking/RankNameBorder.png";
import Rank1Logo from "./ranking/Rank1Logo.png";
import Rank2Logo from "./ranking/Rank2Logo.png";
import Rank3Logo from "./ranking/Rank3Logo.png";
import RankPlayerLogoBorder from "./ranking/RankPlayerLogoBorder.png";
import RankStarLight from "./ranking/RankStarLight.png";
import PlayerLogo from "./ranking/PlayerLogo.png";
import GameRulesTitle from "./popup/gameRulesTitle.png";
import GameRulesLight from "./popup/gameRulesLight.png";
import RulesBackground from "./popup/rulesBckd.png";
import ToggleBgPng from "./popup/switchOnBtn.png";
import ToggleKnobPng from "./popup/toggleKnob.png";
import PersonalDataTitle from "./popup/personalDataTitle.png";
import SettingsTitle from "./popup/settingsTitle.png";
import PlayerGold from "./lobbyTable/PlayerGold.png";
import PlayerGrey from "./lobbyTable/playerGrey.png";
import Table from "./lobbyTable/Table.png";
import LobbyTableChip from "./lobbyTable/lobbyTableChip.png";
import ActiveTablesBtn from "./tournaments/active_tables.png";

//assets for bonus games modal
import BonusGJackpot from "./bonusGames/BonusGJackpot.png";
import BonusGInfoBtn from "./bonusGames/BonusGInfoBtn.png";
import BonusGLogo from "./bonusGames/BonusGLogo.png";
import BGRorB from "./bonusGames/BGRorB.png";
import BGHorDivider from "./bonusGames/BGHorDivider.png";
import BGRorB_Thumb from "./bonusGames/BGRorB_Thumb.png";
import BGTimerWrapper from "./bonusGames/BGTimerWrapper.png";
import BGPlayBtn from "./bonusGames/BGPlayBtn.png";
import BGScratch from "./bonusGames/BGScratch.png";
import BGScratch_Thumb from "./bonusGames/BGScratch_Thumb.png";
import BGSlot from "./bonusGames/BGSlot.png";
import BGSlot_Thumb from "./bonusGames/BGSlot_Thumb.png";
import BGCollectBtn from "./bonusGames/BGCollectBtn.png";
import BGCollectBtnWrapper from "./bonusGames/BGCollectBtnWrapper.png";
import BGRegularDayFrame from "./bonusGames/BGRegularDayFrame.png";
import BGCurrentDayFrame from "./bonusGames/BGCurrentDayFrame.png";
import BGDay1 from "./bonusGames/BGDay1.png";
import BGDay2 from "./bonusGames/BGDay2.png";
import BGDay3 from "./bonusGames/BGDay3.png";
import BGDay4 from "./bonusGames/BGDay4.png";
import BGDay5 from "./bonusGames/BGDay5.png";
import BGVertDividerMobile from "./bonusGames/BGVertDividerMobile.png";
import BGHorDividerMobile from "./bonusGames/BGHorDividerMobile.png";
import BGHorDividerAndTrMobile from "./bonusGames/BGHorDividerAndTrMobile.png";
import BGCollectBtnMobile from "./bonusGames/BGCollectBtnMobile.svg";
import BGCurrentDayFrameMobile from "./bonusGames/BGCurrentDayFrameMobile.png";
import LoginEmail from "./popup/emailLogin.png";
import LoginBackground from "./popup/loginModal.png";
import Login from "./profile/login.png";
import ModalTitle from "./popup/modalTitle.png";
import BtnRanking from "./bottom/btnRanking.png";
import BtnLobby from "./bottom/btnLobby.png";
import BtnBonuses from "./bottom/btnBonuses.png";
import FlagEnPng from "./profile/flagEn.png";
import ArrowDownPng from "./profile/arrowDown.png";
import InviteBckd from "./popup/invitebckd.png";
import InvitePlus from "./popup/invitePlus.png";
import BlueButton from "./tournaments/Btn.png";
import BottomStripPng from "./main/common/BottomStrip.png";
import BottomStripRightPng from "./main/common/BottomStripRight.png";
import ParisPng from "./cities/paris.png";
import MacaoPng from "./cities/macao.png";
import LondonPng from "./cities/london.png";
import MonacoPng from "./cities/monaco.png";
import VegasPng from "./cities/vegas.png";
import SofiaPng from "./cities/sofia.png";
import VipPng from "./cities/vip.png";
import CityBackground from "./cities/citybckgd.png";
import ReportPng from "./profile/report.png";
import LogoPng from "./main/logo.png";
import BgLandscapePng from "./main/bg-landscape.png";
import BgPortraitPng from "./main/bg-portrait.png";
import BottomJackpot from "./bottom/bottomJakcpotBckd.png";
import JackpotCoins from "./bottom/coins.png";
import LoginBckgd from "./login/loginBckgd.png";
import FacebookLogin from "./profile/FacebookBtn.png";
import FacebookButton from "./login/FacebookButton.png";
import GoogleButton from "./login/GoogleButton.png";
// import LoginLogoEn from "./logo_animated/logo_3_card_poker-old.png";
import LogoAnimation from "./logo_animated/logo_3_card_poker.png";
import LogoStatic from "./login/login_background.png";
import JackpotCoin from "./bonusGames/Coins.png";
import JackpotHistory from "./bonusGames/history.png";
import VipBadgeImage from "./profile/avatarFrame/avatar_frame_vip.png";
import LanguageCaret from "./login/caret.png";
import LanguageCaretUp from "./login/caretUp.png";
import BlueTable from "./lobbyTable/blue.png";
import BgTournament from "./main/bg-tournament.png";
import BgTournamentMobile from "./main/bg-tournament-portrait.png";
import TableLogo from "./tables/table_logo.png";
import TableLogoFr from "./tables/table_logo_fr.png";
import TableLogoru from "./tables/table_logo_ru.png";
import TableLogoBg from "./tables/table_logo_bg.png";
import Timer from "./ranking/timer.png";

export {
  BlueTable,
  TableLogo,
  TableLogoFr,
  TableLogoru,
  TableLogoBg,
  Timer,
  BgTournament,
  BgTournamentMobile,
  LanguageCaret,
  LanguageCaretUp,
  ActiveTablesBtn,
  VipBadgeImage,
  LogoPng,
  LogoAnimation,
  LogoStatic,
  JackpotCoin,
  JackpotHistory,
  BgLandscapePng,
  BgPortraitPng,
  ReportPng,
  LoginBckgd,
  FacebookLogin,
  FacebookButton,
  GoogleButton,
  CityBackground,
  ParisPng,
  MacaoPng,
  LondonPng,
  MonacoPng,
  VegasPng,
  SofiaPng,
  VipPng,
  BottomJackpot,
  JackpotCoins,
  BottomStripRightPng,
  BottomStripPng,
  BlueButton,
  InvitePlus,
  MainBtnMobile,
  BronzeButton,
  GoldButton,
  InviteBckd,
  FlagEnPng,
  ArrowDownPng,
  BtnRanking,
  BtnLobby,
  BtnBonuses,
  BuyVipBtn,
  buyNowChips,
  ModalTitle,
  LoginBackground,
  Login,
  LoginEmail,
  LoginTitle,
  LobbyTableChip,
  PlayerGold,
  PlayerGrey,
  Table,
  SettingsTitle,
  PersonalDataTitle,
  ToggleBgPng,
  ToggleKnobPng,
  RulesBackground,
  GameRulesLight,
  GameRulesTitle,
  RewardsPurpleLight,
  RewardsBronzeLight,
  RewardsBlueLight,
  RewardChips,
  SignupBtn,
  RewardChipsIcon,
  EntryChipsIcon,
  TournamentChipsIcon,
  TropheeGold,
  TropheeSilver,
  TropheeBronze,
  TournamentsTrofeeBronze,
  TournamentsTrofeeSilver,
  TournamentsTrofeeGold,
  TournamentsChipImg,
  EntryInfoLight,
  ButtonRegister,
  WinButtonCoins,
  WinButton,
  mainLobbyBtnDesktop,
  mainLobbyBtn,
  mainLobbyBtnActive,
  SearchTitlePng,
  ChipsBackgrOneLand,
  ChipsBackgrTwoLand,
  buyNowPink,
  chipImgOne,
  chipImgTwo,
  ChipsBackgrOne,
  ChipsBackgrTwo,
  goldChipIcon,
  chipImgThree,
  VipBtnLights,
  VipBackgroundLandscape,
  BuyBtn,
  SmallVipOne,
  SmallVipSix,
  SmallVipTwelve,
  VipOneImage,
  VipSixImage,
  VipTwelveImage,
  VipBackground,
  UnderTitleLight,
  GoldTrophee,
  SilverTrophee,
  BronzeTrophee,
  FirstCup,
  SecondCup,
  ThirdCup,
  FirstBackground,
  SecondBackground,
  ThirdBackground,
  TotalLights,
  SilverLights,
  InviteNewPlayerPng,
  RedChipsPng,
  InvitedPlayerBackground,
  InvitesTitlePng,
  LeftArrowPng,
  RightArrowPng,
  LightsLevels,
  TablesContainerPng,
  CityPng,
  BonusesHover,
  RegistrationTitle,
  GoogleBtn,
  FacebookBtn,
  ProfileRegistration,
  LightsHeader,
  SaveBtn,
  SaveButton,
  InputField,
  ProfileTitlePopup,
  ProfileScore,
  ProfileImage,
  BottomButtons,
  DateLights,
  WinsTitle,
  LosesTitle,
  ChipsTitle,
  CircleGold,
  CircleBlue,
  CircleGreen,
  ProfileChipPng,
  ProfileSparklePng,
  ProfileLevelFramePng,
  ProfileLevelProgressBarLightPng,
  ProfileLevelProgressBarFramePng,
  ProfileLevelProgressBarFillPng,
  AvatarFramePng,
  AvatarFrameSparklePng,
  AvatarFrameGradientRedPng,
  AvatarFrameVipPng,
  AvatarFrameGradientGoldPng,
  AvatarFrameGradientBluePng,
  VipBadgeFramePng,
  NotificationBackgroundPng,
  BtnNavChipPng,
  BtnNavBellPng,
  BtnNavOptionsPng,
  BtnMainBackground,
  MainUsersLiveFramePng,
  MainUsersLiveFrameSparklePng,
  TitleMainVipPng,
  BtnMainVipPng,
  TitleMainPlayNowPng,
  BtnMainPlayNowPng,
  TitleMainTournamentsPng,
  BtnMainTournamentsPng,
  BottomPng,
  BottomlPng,
  BottomLightUpPng,
  BottomLightDownPng,
  BtnBottomRankingPng,
  BtnBottomLobbyPng,
  BtnBottomBonusesPng,
  BtnBottomBonusesCollectPng,
  BtnBottomBonusesCollectLightPng,
  SidebarBackgroundPng,
  BtnSidebarClosePng,
  SidebarTopLightPng,
  UsernameFramePng,
  UsernameFrameDownLightPng,
  SidebarLeftLightPng,
  SidebarSeparatorLightPng,
  SidebarAssets,
  NotificationPng,
  RecycleBin,
  MessagesPng,
  HeaderGlow,
  LightLines,
  AvatarModalPng,
  BtnCloseModal,
  BtnEditModal,
  NamePng,
  BtnPhotoModal,
  StarPng,
  ChipPng,
  StatisticsDownLightPng,
  StatisticsText,
  StatisticsUpLightPng,
  TimerBackgroundPng,
  LightBtn,
  RankingTabBtn,
  RankingTabBtnSelected,
  RankBgr1,
  RankBgr2,
  RankBgr3,
  RankBgrRegular,
  RankExp,
  RankChip,
  RankLevelBorder,
  RankNameBorder,
  Rank1Logo,
  Rank2Logo,
  Rank3Logo,
  RankPlayerLogoBorder,
  RankStarLight,
  PlayerLogo,
  BonusGJackpot,
  BonusGInfoBtn,
  BonusGLogo,
  BGRorB,
  BGHorDivider,
  BGRorB_Thumb,
  BGTimerWrapper,
  BGPlayBtn,
  BGScratch,
  BGScratch_Thumb,
  BGSlot,
  BGSlot_Thumb,
  BGCollectBtn,
  BGCollectBtnWrapper,
  BGRegularDayFrame,
  BGCurrentDayFrame,
  BonusGamesModalDays,
  BGVertDividerMobile,
  BGHorDividerMobile,
  BGHorDividerAndTrMobile,
  BGCollectBtnMobile,
  BGCurrentDayFrameMobile,
};

const BonusGamesModalDays = {
  1: BGDay1,
  2: BGDay2,
  3: BGDay3,
  4: BGDay4,
  5: BGDay5,
};
